var TriLifetimeCounter = (function ($) {

    var containerSelector = ".lifetime-seconds:not('.bound')";

    var checkIfContainerExists = function () {
        if ($(containerSelector) !== null &&
            $(containerSelector).length) {
            return true;
        }
        return false;
    };

    var boundLifetimeCounter = function () {
        $(containerSelector).each(function () {

            var elem = $(this);
            elem.addClass('bound');
            var secondsVal = elem.data('seconds');

            if (secondsVal !== undefined && !isNaN(secondsVal)) {
                var interval = setInterval(function () {
                    secondsVal--;

                    var minutes = Math.floor(secondsVal / 60);
                    var seconds = secondsVal - minutes * 60;

                    elem.html(minutes + "m " + seconds + "s");

                    if (secondsVal <= 0) {
                        clearInterval(interval);
                        elem.html("EXPIRED");
                    }
                }, 1000);
            }

        });
    };

    return {
        init: function () {

            if (checkIfContainerExists()) {
                boundLifetimeCounter();
            }
        }
    };

})(window.jQuery);
$(function () {
    TriLifetimeCounter.init();
});

window.TriLifetimeCounter = TriLifetimeCounter;
